import {
  ReactElement,
  useMemo,
  useState,
} from 'react';
import { FormattedMessage } from 'react-intl';

import {
  Color,
  DataType,
} from '@/core/interfaces/common';
import { Modal } from '@/core/components/Modal';
import {
  ArrowExtend,
  ArrowLeft,
  ArrowRight,
} from '@/core/components/Icons';
import { HoverImageWrapper } from '@/core/components/HoverImageWrapper';
import { searchMessages } from '@/core/messages/search.messages';
import { Chip } from '@/core/components/Chip';
import { IconButton } from '@/core/components/IconButton';
import { useTheme } from '@/core/hooks/useTheme';
import { ThemeDirection } from '@/core/constants/constants';
import { ButtonVariant } from '@/core/components/Button';

import { MomentLink as MomentLinkType } from '@/features/Search';

import { getBackendImage } from '@/utils/helpers';

import {

  ChipWrapper,
  Content,
  IconWrapper,
  ResourceImage,
  Subtitle,
  Title,
  Wrapper,
} from '../ResourceLink.styles';

type MediaLinkProps = {
  data: DataType<MomentLinkType>;
}

export const MomentLink = ({
  data,
}: MediaLinkProps) => {
  const theme = useTheme();
  const [
    isModalOpen,
    setIsModalOpen,
  ] = useState(false);

  const {
    attributes: {
      image,
      title,
      subtitle,
    },
  } = data;

  const iconContent = useMemo(() => (
    <IconWrapper>
      <IconButton
        icon={theme.direction === ThemeDirection.LTR ? <ArrowRight /> : <ArrowLeft />}
        variant={ButtonVariant.SECONDARY}
        ariaLabel="open modal"
        onClick={() => setIsModalOpen(true)}
      />
    </IconWrapper>
  ), [theme.direction]);

  return (
    <>
      <Wrapper
        onClick={() => setIsModalOpen(true)}
        aria-label={`open modal for ${title}`}
      >
        <HoverImageWrapper>
          <ResourceImage
            src={getBackendImage(image?.data?.attributes?.url, Color.DARK_GREY)}
            alt={image?.data?.attributes?.alternativeText || title}
          />
        </HoverImageWrapper>
        <Content>
          <Title>
            {title}
          </Title>
          <Subtitle>{subtitle}</Subtitle>
          <ChipWrapper>
            <Chip color={Color.YELLOW}>
              <ArrowExtend size={16} />
              <FormattedMessage {...searchMessages.moment} />
            </Chip>
          </ChipWrapper>

        </Content>
        {iconContent}
      </Wrapper>
      {isModalOpen && (
        <Modal
          isOpen={isModalOpen}
          onRequestClose={() => setIsModalOpen(false)}
          image={getBackendImage(
            image?.data?.attributes?.url
          )}
          alt={image?.data?.attributes?.alternativeText}
          title={subtitle}
          content={title}
        />
      )}
    </>
  );
};
